import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'
import moment from 'moment'

const urlBalancete = '/service/balanceteDespesaRestService/'

class DespesasPorEmpenhoService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
    }

    consultar(filtro) {
        let data = {
            administracao: filtro.administracao,
            exercicio: filtro.exercicio,
            mes: filtro.mes,
            recursoContabil: filtro.recursoContabil,
            codigoDestinacao: filtro.codigoDestinacao,
            orgaoContabil: filtro.orgaoContabil,
            unidadeContabil: filtro.unidadeContabil,
            codigoOrcamentario: filtro.codigoOrcamentario,
            identificacao: filtro.identificacao,
            stnModelo: filtro.stnModelo,
            stnSequencia: filtro.stnSequencia,
            numeroEmpenho: null,
            codigoRubricaEmpenho: null,
            categoriaEmpenho: filtro.categoriaEmpenho,
            tipoFundo: filtro.tipoFundo,
            dataEmpenhoInicial: filtro.dataEmpenhoInicial ? moment(filtro.dataEmpenhoInicial).format() : '',
            dataEmpenhoFinal: filtro.dataEmpenhoFinal ? moment(filtro.dataEmpenhoFinal).format() : '',
        }
        return this.conex.post(urlBalancete + 'recuperaDespesasPorEmpenhoRest/', JSON.stringify(data))
    }
}

export default DespesasPorEmpenhoService
